import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_CLIENTE } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolClienteState extends EntityState<IID_OL_CLIENTE, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_CLIENTE })
@InterfaceDataStore(InterfaceName.CLIENTE)
export class IIDolClienteStore extends EntityStore<IIDolClienteState> {
  constructor() {
    super([]);
  }
}
